// extracted by mini-css-extract-plugin
export default {"Button":"Button_Button__Btfsy","success":"Button_success__Ffjvt","error":"Button_error__LQTgc","primary":"Button_primary__PMj2o"};